
define('text!common/views/email/submissionResponse.html',[],function () { return '<div class="email-sub__message <%=statusClass%>" role="alert" aria-live="assertive">\n    <%=submissionIcon%>\n    <h3 class="email-sub__message__headline"><%=submissionHeadline%></h3>\n    <p class="email-sub__message__description"><%=submissionMessage%></p>\n</div>\n';});

